'use client'
import Image from 'next/image'

import BackDrop from '@/shared/components/BackDrop'
import useNavigationViewModel from '@/shared/components/navigation/components/viewModel'
import Portal from '@/shared/components/Portal'
import Spinner from '@/shared/components/Spinner'
import Toast from '@/shared/components/Toast'
import { Text } from '@/shared/components/typography'
import { useInitNaverSdk } from '@/shared/hooks/useInitNaverSdk'

interface NavigationListViewProps {
  parkinglotName: string
  latitude: number
  longitude: number
  targetId?: string
}

function NavigationListView({ parkinglotName, latitude, longitude, targetId }: NavigationListViewProps) {
  useInitNaverSdk()
  const { states, setters, handlers } = useNavigationViewModel({ parkinglotName, latitude, longitude })

  const NAVIGATION_LIST_DATA = [
    {
      id: 1,
      name: 'Tmap',
      icon: <Image src="/images/light_icn_tmap_32.png" alt="티맵" width={32} height={32} />,
      onClick: handlers.handleTmap
    },
    {
      id: 2,
      name: '네이버 지도',
      icon: <Image src="/images/light_icn_naver_32.png" alt="네이버 지도" width={32} height={32} />,
      onClick: handlers.handleNaverMap
    },
    {
      id: 3,
      name: '카카오내비',
      icon: <Image src="/images/light_icn_kakao_32.png" alt="카카오내비" width={32} height={32} />,
      onClick: handlers.handleKakaoNavi
    }
  ]

  return (
    <>
      <div className="mb-[40px] mt-[24px] w-full">
        {NAVIGATION_LIST_DATA.map(({ id, name, icon, onClick }) => (
          <div key={id} className="flex h-[60px] w-full cursor-pointer items-center justify-between" onClick={onClick}>
            <div className="flex-4 mr-[16px] flex h-[32px] w-[32px] items-center justify-center">{icon}</div>
            <Text level="text3" color="text090" weight="regular" className="flex-1 text-left">
              {name}
            </Text>
          </div>
        ))}
      </div>
      {states.toggleSpinner && (
        <Portal targetId="body">
          <BackDrop isOpen={states.toggleSpinner} />
          <div className="fixed left-1/2 top-1/2 z-170 flex -translate-x-1/2 -translate-y-1/2">
            <Spinner />
          </div>
        </Portal>
      )}

      {states.isToast && (
        <Portal targetId={targetId}>
          <Toast
            text={states.toastText}
            onClose={() => {
              setters.setIsToast(false)
            }}
            position="top"
          />
        </Portal>
      )}
    </>
  )
}

export default NavigationListView
